'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import UIRouterTab from 'ui-addon-react-router-dom/UIRouterTab';
import Draggable from 'UIComponents/draggable/utils/Draggable';

class UIRouterTabClassWrapper extends Component {
  render() {
    return /*#__PURE__*/_jsx(UIRouterTab, Object.assign({}, this.props));
  }

}

export default Draggable(UIRouterTabClassWrapper);